import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { setMapStyle} from '../actions';
import MapControls from '../components/MapControls';

const mapStateToProps = (state) => {
    return{
        map : state.map,
        mapStyle : state.mapStyle,
    }
}

const mapDispatchToProps = (dispatch) => {

    return{
        setMapStyle : bindActionCreators(setMapStyle , dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(MapControls);



// WEBPACK FOOTER //
// ./src/containers/MapControls.js